<app-info-line [icon]="icon" [text]="text()" [additionalClasses]="additionalClasses()" />
